import type { SimulationScore } from '../../cataloglifecycle/framework';
import { cn } from '../../lib/cn';

type Props = { scores?: SimulationScore[] };

function riskColor(risk: SimulationScore['risk']) {
  switch (risk) {
    case 'low': return 'border-success-200 bg-success-50 text-success-700 dark:border-success-900 dark:bg-success-950 dark:text-success-300';
    case 'medium': return 'border-warning-200 bg-warning-50 text-warning-700 dark:border-warning-900 dark:bg-warning-950 dark:text-warning-300';
    default: return 'border-error-200 bg-error-50 text-error-700 dark:border-error-900 dark:bg-error-950 dark:text-error-300';
  }
}

export function SimulationEnginePanel({ scores = [] }: Props) {
  return (
    <div className="grid gap-2 grid-cols-2 sm:grid-cols-3 lg:grid-cols-5">
      {scores.map((s) => (
        <div key={s.label} className={cn('rounded-lg border p-3 text-center', riskColor(s.risk))}>
          <p className="text-2xl font-semibold">{s.score}{s.label === 'Risk' ? '' : '%'}</p>
          <p className="mt-0.5 text-xs font-medium">{s.label}</p>
          <p className="mt-0.5 text-xs capitalize opacity-70">{s.risk} risk</p>
        </div>
      ))}
    </div>
  );
}
